module.exports = __webpack_public_path__ + "static/media/Heart.ba90a19f.svg";